import { logger } from "#app/monitoring/Logger";
import {
  isNestingOptimization,
  isProcessOptimization,
} from "#modules/optimizations/domain/optimizationFilters";
import { OptimizationDto } from "#modules/optimizations/infra/computeOptimizations.api";
import { NestingOptimizationDetail } from "#modules/optimizations/view/NestingOptimizationDetail";
import { ProcessOptimizationDetail } from "#modules/optimizations/view/ProcessOptimizationDetail";

type Props = {
  optimization: OptimizationDto;
  onBack: () => void;
  onRequestBack: () => void;
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
};

export const OptimizationDetail = ({
  optimization,
  onBack,
  onRequestBack,
  onUnsavedChangesChange,
}: Props) => {
  if (isProcessOptimization(optimization)) {
    return (
      <ProcessOptimizationDetail
        optimization={optimization}
        onBack={onBack}
        onRequestBack={onRequestBack}
        onUnsavedChangesChange={onUnsavedChangesChange}
      />
    );
  }

  if (isNestingOptimization(optimization)) {
    return (
      <NestingOptimizationDetail
        optimization={optimization}
        onBack={onBack}
        onRequestBack={onRequestBack}
        onUnsavedChangesChange={onUnsavedChangesChange}
      />
    );
  }

  logger.error(new Error(`Unsupported optimization type for optimization ${optimization.id}`));
  return null;
};
